<template>
  <div>
    <div class="custom-css" style="height: 100%; width: 100%">
      <svg
        data-v-084645b0=""
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        preserveAspectRatio="none meet"
        class=""
        style="height: 100%; width: 100%"
      >
        <circle
          data-v-453a813c=""
          class=""
          :cx="component.width/2"
          :cy="component.height/2"
          :r="component.height/2 - 12"
          :stroke="option.color"
          :stroke-width="option.lineWidth"
          :fill="option.fillColor == ''?'transparent': option.fillColor"
          :stroke-dasharray="dashPattern"
           :class="classType"
        ></circle>
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: "avue-echart-Round",
  props: {
    option: Object,
    component: Object,
  },
  data() {
    return {};
  },
  computed: {
    dashPattern() {
      switch (this.option.lineType) {
        case "solid":
          return ""; // 实线
        case "dotted":
          return "5 5"; // 点线
        case "dashed":
          return "10 10"; // 虚线
        case "dashdot":
          return "10 10 2 10"; // 混合线：虚线+点线
        default:
          return ""; // 默认实线
      }
    },
    classType(){
      if(this.option.lineType == 'solid' || this.option.lineAnimation == ''){
        return ''
      }
      return this.option.lineFlow == 'positive' ? `animation-positive-${this.option.lineType}`:`animation-reverse-${this.option.lineType}`; 
    }
  },
};
</script>

<style scoped>
 @import url("../index.css");
</style>